import React, { useState, useEffect } from "react";
import * as PR from "../../../prime-modules/index";

const PopularCountryItem = ({ 
    item, 
    index, 
    allCountries, 
    saveHandler, 
    editKey, 
    setEditKey, 
    moveUp, 
    moveDown, 
    lastIndex, 
    loading, 
    cancelNewItem 
}) => {
    const id = item.id || `pc-${index}`;
    const [enableEdit, setEnableEdit] = useState(!item.name && !item.iso);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [geogType, setGeogType] = useState(item.geog_type || "Local");
    const [errors, setErrors] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);

    const geogTypes = [
        { name: "Local", value: "Local" },
        { name: "Regional", value: "Regional" }
    ];

    useEffect(() => {
        if (!item.name && !item.iso) {
            setEnableEdit(true);
            setEditKey(id);
        } else {
            const found = allCountries.find(c => c.iso === item.iso);
            if (found) {
                setSelectedCountry(found);
            }
        }
    }, [item.name, item.iso, allCountries, id, setEditKey]);

    const handleSave = () => {
        if (!selectedCountry) {
            setErrors({ country: "Please select a country" });
            return;
        }
        setErrors({});
        saveHandler({
            name: selectedCountry.name,
            region: selectedCountry.region,
            iso: selectedCountry.iso,
            geog_type: geogType,
            id: id
        }, index);
        setEnableEdit(false);
        setEditKey("");
    };

    const handleCancel = () => {
        if (!item.name && !item.iso) {
            cancelNewItem();
        } else {
            const found = allCountries.find(c => c.iso === item.iso);
            setSelectedCountry(found);
            setGeogType(item.geog_type || "Local");
            setEnableEdit(false);
            setEditKey("");
        }
        setErrors({});
    };

    const handleDelete = () => {
        saveHandler(null, index, 'delete');
        setDeleteModal(false);
    };

    return (
        <div className={`popular-country-item ${enableEdit ? "item-editing" : ""} ${loading ? "loading-state" : ""}`}>
            <div className="grid align-items-end">
                <div className="col-4">
                    <label className="block mb-2">Country</label>
                    <PR.Dropdown
                        value={selectedCountry}
                        options={allCountries}
                        onChange={(e) => setSelectedCountry(e.value)}
                        optionLabel="name"
                        placeholder="Select Country"
                        filter
                        disabled={!enableEdit}
                        className="w-full"
                    />
                    {errors.country && <div className="error-msg">{errors.country}</div>}
                </div>
                <div className="col-2">
                    <label className="block mb-2">Region</label>
                    <PR.InputText
                        value={selectedCountry?.region || ""}
                        disabled
                        placeholder="Region"
                        className="w-full"
                    />
                </div>
                <div className="col-1">
                    <label className="block mb-2">ISO</label>
                    <PR.InputText
                        value={selectedCountry?.iso || ""}
                        disabled
                        placeholder="ISO"
                        className="w-full"
                    />
                </div>
                <div className="col-2">
                    <label className="block mb-2">Geo Type</label>
                    <PR.Dropdown
                        value={geogType}
                        options={geogTypes}
                        onChange={(e) => setGeogType(e.value)}
                        optionLabel="name"
                        optionValue="value"
                        disabled={!enableEdit}
                        className="w-full"
                    />
                </div>
                
                <div className="col-3 popular-country-buttons text-right">
                    {!enableEdit ? (
                        <div className="flex justify-content-end gap-2">
                            <PR.Button icon="pi pi-arrow-up" className="outline-button" onClick={() => moveUp(index)} disabled={editKey || index === 0} />
                            <PR.Button icon="pi pi-arrow-down" className="outline-button" onClick={() => moveDown(index)} disabled={editKey || index === lastIndex} />
                            <PR.Button label="Edit" className="add-category-btn" disabled={editKey && editKey !== id} onClick={() => { setEnableEdit(true); setEditKey(id); }} />
                            <PR.Button label="Delete" className="outline-button" disabled={editKey} onClick={() => setDeleteModal(true)} />
                        </div>
                    ) : (
                        <div className="flex justify-content-end gap-2">
                            <PR.Button label="Cancel" className="outline-button" onClick={handleCancel} />
                            <PR.Button label="Save" className="add-category-btn" onClick={handleSave} />
                        </div>
                    )}
                </div>
            </div>

            <PR.Dialog
                header="Delete Popular Country"
                visible={deleteModal}
                draggable={false}
                resizable={false}
                onHide={() => setDeleteModal(false)}
                className="delete-confirm-modal"
            >
                <div className="delete-confirm-content">
                    <p>Are you sure you want to delete this popular country?</p>
                    <div className="text-right">
                        <PR.Button label='Cancel' onClick={() => setDeleteModal(false)} className="outline-button" />
                        <PR.Button label="Delete" className="add-category-btn" onClick={handleDelete} />
                    </div>
                </div>
            </PR.Dialog>
        </div>
    );
};

export default PopularCountryItem;
